import React from "react";
import { Maximize2 } from "lucide-react";
import { useDutyCheckJob } from "@/context/DutyCheckJobContext";

export default function DutyCheckJobOverlay() {
    const { isRunning, isMinimized, expandModal } = useDutyCheckJob();

    if (!isRunning || !isMinimized) {
        return null;
    }

    return (
        <div className="fixed bottom-6 right-6 z-[100] animate-in slide-in-from-bottom-4 duration-300">
            <div className="bg-[#0a1a3f] text-white rounded-2xl shadow-2xl border border-white/10 px-4 py-3 flex items-center gap-3 min-w-[240px]">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin shrink-0" />
                <span className="text-sm font-medium flex-1">Sending status check…</span>
                <button
                    type="button"
                    onClick={expandModal}
                    className="p-1.5 hover:bg-white/10 rounded-lg transition-colors"
                    aria-label="Expand modal"
                    title="Expand"
                >
                    <Maximize2 className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
}
